<section
  *ngIf="!mode && (canCreateAdvancedPlant$ | async) as canCreateAdvancedPlant"
  class="custom-block fx-col fx-gap-3 p-6">
  <div class="fx-row fx-justify-evenly fx-wrap fx-gap-3 text-grey-400 text-300 body-2">
    <div class="fx-col fx-gap-3 w-120">
      <div class="fx-row fx-center fx-gap-2 tw-text-lg tw-font-medium">
        <mat-icon
          class="s-6 min-s-6"
          svgIcon="block_expired">
        </mat-icon>
        <span>{{ labels.legacyPlant }}</span>
      </div>
      <div
        class="description-contrainer"
        [innerHTML]="labels.legacyDescription">
      </div>
    </div>

    <div class="fx-col fx-gap-3 w-120">
      <div class="fx-row fx-center fx-gap-2 tw-text-lg tw-font-medium">
        <mat-icon
          class="s-6 min-s-6"
          svgIcon="block_verified">
        </mat-icon>
        <span>{{ labels.verifiedPlant }}</span>
      </div>
      <div
        class="description-contrainer"
        [innerHTML]="labels.verifyDescription">
      </div>
    </div>
  </div>
  <customer-choice-with-img
    class="bg-grey-100 radius-4"
    [labels]="{
      verifiedPlant: labels.verifiedPlant,
      legacyPlant: labels.legacyPlant,
    }"
    [loggers]="plantType">
  </customer-choice-with-img>
  <div
    *ngIf="(unlimitedPlants$ | async) === false"
    class="fx-row fx-justify-evenly fx-wrap fx-gap-3 text-grey-400 text-300 body-2">
    <section class="border-1 fx-center fx-gap-3 p-1 radius-4 radius-2 border-grey-100 w-full">
      <mat-icon class="text-grey-400">
        info
      </mat-icon>
      <customer-title-content
        class="fx-g-1"
        [content]="labels.basicUserCanHaveOnly3Plant">
      </customer-title-content>
    </section>
  </div>
  <section class="border-1 fx-center fx-gap-3 p-1 radius-4 radius-2 border-accent bg-accent-100 w-full">
    <mat-icon class="text-accent">
      info
    </mat-icon>
    <customer-title-content
      class="fx-g-1"
      [style.--content-color]="'var(--accent)'"
      [content]="labels.ifYouHaveAnAzzurroHubLoggerYouNeedAnAdvancedPlant">
    </customer-title-content>
  </section>
  <button
    class="custom-mat-button-primary"
    mat-button
    [disabled]="!isPlantTypeSelected"
    (click)="confirmPlantType()">
    {{ labels.confirm }}
  </button>
</section>

<create-firebase-block
  *ngIf="mode === 'firebase'"
  [labels]="labels"
  [stepperOrientation]="stepperOrientation"
  [systems$]="systems$"
  (wizardExit)="wizardExit.emit()"
  (wizardFinished)="wizardFinished.emit($event)"
  (onReset)="reset()">
</create-firebase-block>

<create-aws-block
  *ngIf="mode === 'aws'"
  [labels]="labels"
  [stepperOrientation]="stepperOrientation"
  [systems$]="systems$"
  (wizardExit)="wizardExit.emit()"
  (wizardFinished)="wizardFinished.emit($event)"
  (onReset)="reset()">
</create-aws-block>
